module.exports = __webpack_public_path__ + "static/media/sort-arrow-up.a5ab0491.svg";